/** @format */

import React from 'react';
import './styles.scss';
import PageLayout from 'components/Layout/Page';
import {
  LeadsSectionBody,
  LeadSources,
  LeadTypes
} from 'components/LeadsGenerator';

export default function LeadsCommonPage(props) {
  const text = props.t('lang_common:leads_page:buy');

  const ImageSection = () => {
    return (
      <img
        src='/images/leads-buy-page.jpg'
        className='buy-page-image'
        alt='leads Buy image'
      />
    );

    // return <></>;
  };
  return (
    <PageLayout mainContainerClassName='leads-page buy-page' {...props}>
      <div className='buy-page-wrapper'>
        <div className='form-section'>
          <div className='header-section'>
            <h3>{text?.heading}</h3>
            <p className='text2r'>{text?.headerParagraph}</p>
          </div>
          <LeadsSectionBody
            metadata={{
              source: LeadSources.FM_BUY
            }}
            defaultLeadType={LeadTypes.BUY}
            {...props}
          />
        </div>
        <div className='image-section'>
          <ImageSection />
        </div>
      </div>
    </PageLayout>
  );
}
